import { combineReducers } from 'redux'

import { welcomeProfile } from './welcome'

export const welcomeReducer = combineReducers({
  welcomeProfile
})
